//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { getAction } from '@/api/manage';
import MessageIssuedModal from "./MessageIssuedModal";
import Vue from 'vue';
export default {
  name: 'MessageIssued',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    MessageIssuedModal: MessageIssuedModal
  },
  data: function data() {
    return {
      pageTitle: '报文下发',
      expandedKeys: [],
      addDisabled: false,
      // 表头
      isorter: {
        column: 'create_time',
        order: 'desc'
      },
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点名称',
        align: 'center',
        sorter: true
      },
      columns: [{
        title: '下发时间',
        align: 'center',
        dataIndex: 'createTime'
      }, {
        title: '报文编号',
        align: 'center',
        dataIndex: 'qn'
      }, {
        title: '命令',
        align: 'center',
        dataIndex: 'cn'
      }, {
        title: '报文flag',
        align: 'center',
        dataIndex: 'flag'
      }, {
        title: '下发人',
        align: 'center',
        dataIndex: 'createBy_userName'
      }, {
        title: '下发结果',
        align: 'center',
        dataIndex: 'status_dictText'
      }],
      url: {
        list: '/online/message/issued'
      },
      autoLoadInit: false,
      siteTree: [],
      queryParam: {}
    };
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      console.log(value);
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.addDisabled = false;
        this.queryParam.siteId = ids[1];
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.addDisabled = true;
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
    }
  },
  computed: {},
  created: function created() {//this.loadSiteTree()
  },
  methods: {
    searchReset: function searchReset() {
      var siteId = this.queryParam.siteId;
      this.queryParam = {};
      this.queryParam.siteId = siteId;
      this.queryParam.cn = this.tabIds == '' ? this.tabId : this.tabIds;
      this.dates = {};
      this.loadData(1);
    },
    // 树形
    onExpand: function onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
    },
    handleAdd: function handleAdd() {
      var record = {};
      record.siteId = this.queryParam.siteId;
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = this.pageTitle;
    },
    // 新增/修改 成功时，重载列表
    modalFormOk: function modalFormOk() {
      var record = {};
      record.siteId = this.queryParam.siteId;
      this.queryParam = record;
      this.loadData();
    },
    onDateChange: function onDateChange(value, dateString) {
      this.queryParam.beginTime = dateString[0];
      this.queryParam.endTime = dateString[1];
    }
  }
};